import { render, staticRenderFns } from "./commodities.html?vue&type=template&id=1fddc856&scoped=true&"
import script from "./commodities.js?vue&type=script&lang=js&"
export * from "./commodities.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fddc856",
  null
  
)

export default component.exports